import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "react-modal";
import { Container, Row, Col } from "react-bootstrap";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import PlanPauseListings from "../../components/pause-system/pause-crud/PlanPauseListings";
import PlanPauseForm from "../../components/pause-system/pause-crud/PlanPauseForm";
import { fetchAllPlanPauseData } from "../../redux/plans-reducers/plansSlice";

const PauseSystem = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);

  const { planPauseLoading } = useSelector((state) => state.plans);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedPlanDuration: "",
    isActive: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    plan_duration: allFilters?.selectedPlanDuration?.value || "",
    status: allFilters?.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getAllPlanPause(filters = {}) {
    dispatch(
      fetchAllPlanPauseData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getAllPlanPause(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      plan_duration: allFilters?.selectedPlanDuration?.value || "",
      status: allFilters?.isActive?.value || "",
    }));
  }, [isPage, pageLimit, allFilters]);

  return (
    <HelmetWrapper title="WTF: Pause Criteria">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}>
          <div className={`createNewCTOModalContainer mod-width-50p`}>
            {modValues.modName === "add" || modValues.modName === "edit" ? (
              <PlanPauseForm
                userInfoData={userInfoData}
                rowData={modValues.rowData}
                isEdit={modValues.modName === "edit"}
                closeModal={onCloseModal}
                callFunction={() => getAllPlanPause(filters)}
              />
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Membership Pause System"}
              isReload={() => getAllPlanPause(filters)}
              createBtnTxt={"+ Add New Plan Pause"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  modName: "add",
                }))
              }
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from={"pause-system"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              isLoading={planPauseLoading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <PlanPauseListings
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
              callFunction={() => getAllPlanPause(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default PauseSystem;
